<template>
  <div class="tables">
    <div class="tables-left">
      <!-- <el-form :inline="true" :model="formData" class="demo-form-inline form-two" v-if="isEdit">
        <el-form-item label="物品名称:">
          <el-input class="w-208" @input="searchYao" v-model="formData.name" clearable placeholder="名称/拼音">
            <template #suffix>
              <div @click="searchYao" class="searchcss">
                <i class="fa fa-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="批号">
          <el-input class="w-208" @input="searchYao" @clear="closeDrugList" v-model="formData.batch_no"
            @keydown.enter="searchYao" clearable placeholder="批号">
          </el-input>
        </el-form-item>
      </el-form> -->
      <el-form :inline="true" :model="formDataSearch" class="demo-form-inline form-two">
        <el-form-item label="物品名称:">
          <el-input class="w-208" @input="tobodyPDInput" v-model="formDataSearch.name" clearable placeholder="名称/拼音">
            <template #suffix>
              <div @click="tobodyPD" class="searchcss">
                <i class="fa fa-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="批号">
          <el-input class="w-208" @input="tobodyPDInput" v-model="formDataSearch.batch_no" @keydown.enter="tobodyPD"
            clearable placeholder="批号">
          </el-input>
        </el-form-item>
        <el-form-item label="入库单号">
          <el-input v-model="formDataSearch.order_no" @input="tobodyPDInput" clearable />
        </el-form-item>
        <el-form-item label="差额类型">
          <el-select v-model="formDataSearch.type" clearable placeholder="请选择" @change="tobodyPD">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :model="addRuleForm" ref="ruleFormPdRef" label-width="60px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="备注：">
              <el-input type="textarea" placeholder="请输入备注" :disabled="!isEdit" v-model="addRuleForm.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="showYaoList" class="scheme-cont" v-loading="contLoading">
        <div class="display_flex">
          <div></div>
          <div class="iconSet" @click="closeDrugList"><el-icon>
              <Close />
            </el-icon></div>
        </div>
        <div class="drug-list">
          <el-scrollbar ref="schemeRef" id="resultScroll">
            <el-table @row-click="addList" v-loading="dataListLoading" :data="tableDataYao" size="small" stripe border
            max-height="250px" width="100%">
              <el-table-column width="200" property="drug.name" label="名称" />
              <el-table-column width="180" prop="order_no" label="入库单号" />
              <el-table-column width="180" prop="batch_no" label="批号" />
              <el-table-column property="name" label="规格">
                <template #default="scope">
                  <span>
                    {{scope.row.medi_spec}}*{{ scope.row.min_package_num }} {{ scope.row.min_unit_name }} /
                    {{ scope.row.min_package_unit_name }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column property="company" label="厂商" />
            </el-table>

          </el-scrollbar>
        </div>
      </div>
      <el-table v-loading="dataListLoading" size="small" :data="tableDataPD" border style="width: 100%">
        <el-table-column width="230" prop="drug_name" label="名称" show-overflow-tooltip/>
        <el-table-column width="150" prop="order_no" label="入库单号" show-overflow-tooltip/>
        <el-table-column width="150" prop="batch_no" label="批号" show-overflow-tooltip/>
        <el-table-column  label="规格" show-overflow-tooltip>
        <template #default="scope">
          <span>
            {{scope.row.drug_medi_spec}}*{{ scope.row.drug_min_package_num }} {{ scope.row.drug_min_unit_name }} /
            {{ scope.row.drug_min_package_unit_name }}
          </span>
        </template>
        </el-table-column>
        <el-table-column label="计算数量" width="100">
          <template #default="scope">
            <div class="display_flex">
              {{scope.row.store_num}}{{scope.row.drug_min_package_unit_name}}{{scope.row.store_sub_num}}{{scope.row.drug_min_unit_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="盘点数量" width="180">
          <template #default="scope">
            <div class="display_flex" v-if="isEdit">
              <el-input size="small" v-model="scope.row.check_num" @change="checkNumChange(e,scope.row)" style="margin-right: 4px;">
                <template #append>{{scope.row.drug_min_package_unit_name}}</template>
              </el-input>
              <el-input size="small" v-model="scope.row.check_sub_num" @change="checkSubNumChange(e,scope.row)">
                <template #append>{{scope.row.drug_min_unit_name}}</template>
              </el-input>
            </div>
            <div class="display_flex" v-if="!isEdit">
              {{scope.row.check_num}}{{scope.row.drug_min_package_unit_name}}{{scope.row.check_sub_num}}{{scope.row.drug_min_unit_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="差额" width="70" align="center"/>
        <el-table-column property="drug_company" label="厂家" show-overflow-tooltip />
        <!-- <el-table-column fixed="right" label="操作" width="70" align="center" v-if="isEdit">
          <template #default="scope">
            <el-popconfirm title="是否确定删除?" @confirm="rigthdel(scope.row.record_id)">
              <template #reference>
                <el-link type="danger" v-if="scope.row.addStatus==1">
                  删除
                </el-link>
              </template>
            </el-popconfirm>
            <span v-if="scope.row.addStatus==0">-</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination-box">
        <el-pagination v-model:currentPage="pageDataPD.currentPage" v-model:page-size="pageDataPD.pageSize"
          :page-sizes="[15, 25, 55, 105]" :background="true" layout="total, sizes, prev, pager, next, jumper"
          :total="pageDataPD.totalSum" @size-change="handleSizeChangePD"
          @current-change="handleCurrentChangePD"></el-pagination>
      </div>
      <div class="display_flex">
        <div></div>
        <div class="display_flex">
          <el-button @click="PDBackClick" type="info">
            {{isEdit?'取消':'关闭'}}
          </el-button>
          <el-button @click="saveItem" type="success" :loading="saveLoad" v-if="isEdit">
            保存
          </el-button>
          <el-button class="color-vice" type="primary" @click="exportTable" >
            <i class="fa fa-arrow-down"></i>导出
          </el-button>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {
    reactive,
    ref,
    onMounted,
    defineExpose,
    defineEmits,
    nextTick,
  } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { ElMessage } from 'element-plus'
  import { gitDictList,Antishake, TimeYear, downLoadXlsx, TimestampToTime } from '@/utils/tool'
  const pdList = ref({})
  const dictCatalogType = ref('')
  const loading = ref(false)
  const check_order_id = ref('')
  const formData = ref({})
  const showYaoList = ref(false)
  const tableDataYao = ref([])
  const tableDataPD = ref([])
  const isEdit = ref(false)
  const saveLoad = ref(false)
  
  const typeList = ref([
    {
      name: '全部',
      code: ''
    }, {
      name: '平',
      code: '0'
    }, {
      name: '不平',
      code: '1'
    }
  ])
  const addRuleForm = ref({})
  const formDataSearch = ref({
    name: '',
    batch_no: '',
    order_no: '',
    type:''
  })
  const pageDataPD = ref({
    currentPage: 1,
    pageSize: 15,
    totalSum: 0,
  })
  const check_date = ref('')
  onMounted(() => {

  })
  const initData = (id, code, flag, time) => {
    check_order_id.value = code
    dictCatalogType.value = id
    isEdit.value = flag
    check_date.value = time
    tobodyPD()
  }
  const tobodyPDInput  = () => {
        Antishake(tobodyPD(), 2000)
      }
  // 修改入库单号
  const formSearchOrderChange = (val) => {
    formDataSearch.vaule.order_no = val
    pageDataPD.vaule.currentPage = 1
    tobodyPD()
  }
  const em = defineEmits(['refreshDataList'])
  const tobodyPD = async () => {
    loading.value = true
    let data = {
      size: pageDataPD.value.pageSize,
      page: pageDataPD.value.currentPage,
      check_order_id: check_order_id.value,
      dict_catalog_type: dictCatalogType.value,
      ...formDataSearch.value
    }
    let res = await service.post('/api/storeDrugCheck/getOrderDetail', data)
    if (res.code === 0) {
      if (res.data.total > 0) {
        res.data.list.forEach(item => {
          item.addStatus = 0
          if (item.drug_min_package_unit_name == item.drug_min_unit_name) {
            item.num = (item.check_num + item.check_sub_num) - (item.store_num + item.store_sub_num)
          } else {
            item.num = (item.check_num * Number(item.drug_min_package_num) + item.check_sub_num) - (item.store_num * Number(item.drug_min_package_num) + item.store_sub_num)
          }
        })
        tableDataPD.value = res.data.list
        pageDataPD.value.totalSum = res.data.total
      } else {
        tableDataPD.value = []
        pageDataPD.value.totalSum = 0
      }
    }
    loading.value = false
  }
  // 条数改变时
  const handleSizeChangePD = (e) => {
    pageDataPD.value.pageSize = e
    tobodyPD()
  }
  // 页数改变时
  const handleCurrentChangePD = (e) => {
    pageDataPD.value.currentPage = e
    tobodyPD()
  }
  // 搜索
  const searchYao = () => {
    // 入库列表点击之后获取药品信息
    RKLBCGetInfo()
  }
  const closeDrugList = () => {
    formData.value.searchs = ''
    showYaoList.value = false
  }
  const checkNumChange = (e, item) => {
    console.log(item)
    if (item.drug_min_package_unit_name == item.drug_min_unit_name) {
      let a = (Number(item.check_num) + Number(item.check_sub_num)) - (Number(item.store_num) + Number(item.store_sub_num))
      console.log(a)
      item.num = a
    } else {
      let a = (Number(item.check_num) * Number(item.drug_min_package_num) + Number(item.check_sub_num)) - (Number(item.store_num) * Number(item.drug_min_package_num) + Number(item.store_sub_num))
      console.log(a)
      item.num = a
    }
  }
  const checkSubNumChange = (e, item) => {
    console.log(item)
    if (item.drug_min_package_unit_name == item.drug_min_unit_name) {
      let a = (Number(item.check_num) + Number(item.check_sub_num)) - (Number(item.store_num) + Number(item.store_sub_num))
      console.log(a)
      item.num = a
    } else {
      let a = (Number(item.check_num) * Number(item.drug_min_package_num) + Number(item.check_sub_num)) - (Number(item.store_num) * Number(item.drug_min_package_num) + Number(item.store_sub_num))
      console.log(a)
      item.num = a
    }
  }
  // 获取药品/耗材列表
  const RKLBCGetInfo = async () => {
    showYaoList.value = true
    let data = {
      current: 1,
      size: 20,
      name: formData.value.name,
      batch_no: formData.value.batch_no,
      dict_catalog_type: dictCatalogType.value,
    }
    let res = await service.post('/api/store_enter_record/get_enter_record_list', data)
    if (res.code === 0) {
      if (res.data.total > 0) {
        tableDataYao.value = res.data.records
        pageDataPD.value.totalSum = res.data.total
      } else {
        pageDataPD.value.totalSum = 0
        tableDataYao.value = []
      }
    }
  }

  //添加到右侧列表数据
  const addList = async (row) => {

    let data = {
      check_order_id: check_order_id.value,
      drug_id: row.drug_id,
      order_no: row.order_no,
      batch_no: row.batch_no,
    }
    let res = await service.post('/api/storeDrugCheck/createDetailValidate', data)
    if (res.code == 0) {
      if (res.data.data == true) {
        showYaoList.value = false
        formData.value.searchs = ''

        let param = {
          addStatus: 1,
          record_id: row.id,
          drug_id: row.drug_id,
          order_no: row.order_no,
          batch_no: row.batch_no,
          drug_name: row.drug.name,
          drug_medi_spec: row.drug.medi_spec,
          drug_company: row.drug.company,
          drug_country_code: row.drug.country_code,
          drug_min_package_num: row.drug.min_package_num,
          drug_min_package_unit: row.drug.min_package_unit,
          drug_min_package_unit_name: row.drug.min_package_unit_name,
          drug_min_unit_name: row.drug.min_unit_name,
          drug_min_unit: row.drug.min_unit,
          drug_dict_first_unit_name: row.drug.dict_first_unit_name,
          drug_dict_first_unit: row.drug.dict_first_unit,
          check_num: row.check_num == undefined ? 0 : row.check_num,
          check_sub_num: row.check_sub_num == undefined ? 0 : row.check_sub_num,
          store_num: row.store_num == undefined ? 0 : row.store_num,
          store_sub_num: row.store_sub_num == undefined ? 0 : row.store_sub_num,
          drug: '',
        }
        if (param.drug_min_package_unit_name == param.drug_min_unit_name) {
          let a = (Number(param.check_num) + Number(param.check_sub_num)) - (Number(param.store_num) + Number(param.store_sub_num))
          console.log(a)
          param.num = a
        } else {
          let a = (Number(param.check_num) * Number(param.drug_min_package_num) + Number(param.check_sub_num)) - (Number(param.store_num) * Number(param.drug_min_package_num) + Number(param.store_sub_num))
          console.log(a)
          param.num = a
        }
        tableDataPD.value.unshift(param)
        formData.value = {}
      } else {
        ElMessage.error('药品已在盘点单中！');
      }
    }
  }
  const rigthdel = (id) => {
    console.log(tableDataPD.value.findIndex(item => item.id === id))
    tableDataPD.value.splice(tableDataPD.value.findIndex(item => item.record_id === id), 1)
  }
  //点击盘点返回事件
  const PDBackClick = () => {
    // PDMain = true
    em('refreshDataList')
    formData.value = {}
    // tobody()
  }
  //保存
  const saveItem = async () => {
    saveLoad.value = true
    let data = {
      remark:addRuleForm.value.remark,
      check_order_id: check_order_id.value,
      list: tableDataPD.value,
      dict_catalog_type: dictCatalogType.value,
    }
    let res = await service.post('/api/storeDrugCheck/saveOrderDetail', data)
    if (res.code == 0) {
      saveLoad.value = false
      ElMessage({
        message: '盘点成功',
        type: 'success',
      })
      tobodyPD()
    }else{
      saveLoad.value = false
    }
  }
  const exportTable = async () => {
    let data = {
      check_order_id: check_order_id.value,
      dict_catalog_type: dictCatalogType.value
    }
    let time = TimestampToTime()
    let title = ''
    if (dictCatalogType.value == '164000000') {
      title = `科室耗材盘点${time}.xlsx`
    } else {
      title = `科室药品盘点${time}.xlsx`
    }
    downLoadXlsx('/api/export/exportInventoryOrderDetail', data, title)
  }
  defineExpose({
    initData,
    saveItem,
    PDBackClick,
    tobodyPD
  })
</script>

<style scoped lang="scss">
  .display_flex {
    display: flex;
    justify-content: space-between;
  }

  .scheme-cont {
    border: 1px solid #ccc;
    position: fixed;
    width: 70%;
    z-index: 99999999;
    background: #fff;

    .drug-list {
      width: 100%;
    }

    .item {
      height: 32px;
      line-height: 32px;
      width: 100%;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Medium';
      color: #444444;
      padding-right: 14px;
      margin-bottom: 12px;

      .lable {
        background-color: #ffffff;
        border-radius: 4px;
        padding-left: 20px;
        cursor: pointer;
      }

      &.active {
        border-right: 4px solid #3166ae;

        .lable {
          background-color: rgba(49, 102, 174, 0.3);
          color: #3166ae;
        }
      }

      &:hover {
        .lable {
          background-color: rgba(49, 102, 174, 0.3);
          color: #3166ae;
        }
      }
    }
  }
</style>
